import React from "react";

export default function PageHero({ eyebrow, title, subtitle, image, tall = false, children }) {
  return (
    <section
      className={`relative overflow-hidden ${tall ? "min-h-[72vh]" : "min-h-[54vh]"} flex items-center`}
      data-testid="page-hero"
    >
      <div className="absolute inset-0">
        <img
          src={image}
          alt=""
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/75" />
        <div className="absolute inset-0 bg-[#0B5D1E]/25 mix-blend-multiply" />
      </div>

      <div className="relative gk-container py-24 sm:py-28 text-white w-full">
        <div className="max-w-3xl">
          {eyebrow && (
            <span className="inline-flex items-center gap-3 text-xs font-bold tracking-[0.25em] uppercase text-[#E8F1EA] mb-5">
              <span className="h-[2px] w-10 bg-[#14803C]" />
              {eyebrow}
            </span>
          )}
          <h1 className="font-heading font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-white">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-lg sm:text-xl text-white/85 max-w-2xl leading-relaxed">
              {subtitle}
            </p>
          )}
          {children && <div className="mt-10">{children}</div>}
        </div>
      </div>
    </section>
  );
}
